import { render, staticRenderFns } from "./DialogLightbox.vue?vue&type=template&id=d25aacd6&scoped=true&"
import script from "./DialogLightbox.vue?vue&type=script&lang=js&"
export * from "./DialogLightbox.vue?vue&type=script&lang=js&"
import style0 from "./DialogLightbox.vue?vue&type=style&index=0&id=d25aacd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d25aacd6",
  null
  
)

export default component.exports